import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    accessToken: null,
    activityAccessToken: null,
    supplier_id: null,
  },
  reducers: {
    setAccessToken: (state, action) => {
      state.accessToken = action.payload;
    },
    setSupplierId: (state, action) => {
      state.supplier_id = action.payload;
    },
  },
});

export const { setAccessToken, setSupplierId } = authSlice.actions;
// export const authSelector = (state) => state.auth;

export default authSlice.reducer;
